import React from 'react'

import { Alert } from '_zari/core'

import { EstadosLetrasPendientes } from 'constants/index'

const AlertItem = ({ letraInfo }) => {
  const color = React.useMemo(() => {
    if (letraInfo.estado === EstadosLetrasPendientes.A_VENCER) {
      return 'info'
    } else if (letraInfo.estado === EstadosLetrasPendientes.VENCE_HOY) {
      return 'warning'
    } else if (letraInfo.estado === EstadosLetrasPendientes.VENCIDO) {
      return 'danger'
    } else {
      return 'light'
    }
  }, [letraInfo.estado])

  return (
    <Alert color={color}>
      <span>
        <b>PROVEEDOR : </b> {letraInfo.numeroDocumentoSocio} - {letraInfo.razonSocialSocio}
        <br />
        <b>DOCUMENTO : </b> {letraInfo.tipoDocumento} - {letraInfo.serieDocumento} - {letraInfo.numeroDocumento}
        <br />
        <b>MONEDA : </b> {letraInfo.moneda}
        <br />
        <b>MONTO : </b> {letraInfo.montoPendiente}
        <br />
        <b>ESTADO : </b> {EstadosLetrasPendientes.__dictionary[letraInfo.estado].nombre}
      </span>
    </Alert>
  )
}

export default React.memo(AlertItem)

// estado: "VENC"
